module.exports = __webpack_public_path__ + "d94e20c1/img/placeholder.888fcd0b.svg";